import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  IMAGE_BORDER_RADIUS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import {Button, GridList} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import AddIcon from '@material-ui/icons/Add';
import constants from "../../constants";
import {ColorActivityFormImage} from "src/styles/Colors";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import ValueHelper, {getInitialFiles} from "../../utils/ValueHelper";
import {cloneDeep, map} from "lodash";
import {IMAGE_MAX_SIZE, IMAGE_MAX_WIDTH_HEIGHT} from "../commons/FilePicker";
import FileHelper from "../../utils/FileHelper";
import SingleFilePicker, {
  ACCEPTED_AUDIO_MIMES,
  ACCEPTED_IMAGE_MIMES, AUDIO_MAX_SIZE,
  FILE_TYPE_AUDIO,
  FILE_TYPE_IMAGE,
  IMAGE_PROFILE_MAX_WIDTH_HEIGHT
} from "../commons/SingleFilePicker";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FieldSpace from "src/js/components/commons/FieldSpace";
import SectionHeaderView, {
  SECTION_HEADER_WITH_SUBTITLE_BOTTOM_SPACE
} from "src/js/components/commons/SectionHeaderView";
import MediaPlaceholder from "src/js/components/commons/MediaPlaceholder";
import Switch from "@material-ui/core/Switch";

const useStyles = () => ({
  imageCustomise: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    padding: 8,
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityFormImage,
    minWidth: 260,
    width: '100%',
    margin: 1,
    marginBottom: 16 + 1,
  },
  imageCustomisePlaceholderImage: {
    width: 48,
    height: 48,
    borderRadius: IMAGE_BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageCustomiseQuestion: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    // border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityFormImage,
    marginBottom: 16,
    padding: 4,
  },
});

class ManageActivityQuestion extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;

    this.maxOptionsCount = 4;
    if (activityData.type === constants.activity.types.QUESTION) {
      this.maxOptionsCount = 8;
    }
    this.maxGamePlayAudioDuration = 10*1000;
    this.maxBgAudioDuration = 60;
    if (activityData.mediaConfigs) {
      this.maxGamePlayAudioDuration = activityData.mediaConfigs.maxGamePlayAudioDuration;
      this.maxBgAudioDuration = activityData.mediaConfigs.maxBgAudioDuration;
    }
    // this.isQuestionReset = false;
    // if (activityData.qOptions && activityData.qOptions.length > 0 && activityData.qOptions[0].id < 0) {
    //   activityData.qOptions = null;
    //   activityData.qTitle = null;
    //   this.isQuestionReset = true;
    // }

    const rightOptions = [];
    this.qOptions = [];
    let optionNo = 1;
    if (activityData.qOptions) {
      activityData.qOptions.forEach((optionL) => {
        const option = {
          optionNo: optionNo,
          id: optionL.id,
          name: optionL.name,
          nameAr: optionL.nameAr || ''
        };
        this.qOptions.push(option);
        rightOptions.push(option);

        optionNo++;
      });
    }
    if (this.qOptions.length < this.maxOptionsCount) {
      for (let i = this.qOptions.length; i < this.maxOptionsCount; i++) {
        this.qOptions.push({
          id: -(i + 1),
          optionNo: optionNo,
          name: '',
          nameAr: '',
        });
        optionNo++;
      }
    }

    this.state = {
      sections: [
        {id: 1, labelId: 'activity.correctAnswer', subLabelId: 'activity.correctAnswerHint', expand: true, expandAlways: true},
      ],
      showAnswers: activityData.showAnswers == true,
      correction: activityData.correction == true,
      qTitle: activityData.qTitle || '',
      qTitleAr: activityData.qTitleAr || '',
      rightOption: activityData.rightOption || '',
      imageUrl2: activityData.imageUrl2,
      imageFiles2: activityData.imageFiles2,
      fileObjsImage2: activityData.fileObjsImage2,
      isImageDeleted2: activityData.isImageDeleted2,
      bgAudioUrl: activityData.bgAudioUrl,
      bgAudioFiles: activityData.bgAudioFiles,
      isBgAudioDeleted: activityData.isBgAudioDeleted,
      rightOptions: rightOptions,
      showValidationMsg: false,
      reload: false
    };

    this.initialFiles2 = getInitialFiles(activityData.imageFiles2, activityData.imageUrl2, FILE_TYPE_IMAGE);
    this.bgAudioInitialFiles = getInitialFiles(activityData.bgAudioFiles, activityData.bgAudioUrl, FILE_TYPE_AUDIO);
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    // if (this.isQuestionReset) {
    //   this.props.onDataUpdated(this.getData(true));
    // }
  }

  componentWillUnmount() {
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getData(excludeError) {
    const {
      showAnswers,
      correction,
      qTitle,
      qTitleAr,
      rightOption,
      imageUrl2,
      imageFiles2,
      fileObjsImage2,
      isImageDeleted2,
      bgAudioUrl,
      bgAudioFiles,
      isBgAudioUrlDeleted,
    } = this.state;

    if (!excludeError) {
      if (this.isQuestionTitleIncorrect(qTitle)
        || (!this.qOptions || this.qOptions.length === 0)
        || this.isRightOptionIncorrect()
        || !this.areQuestionOptionsCorrect()
      ) {
        this.updateState({showValidationMsg: true});
        return false;
      }
    }

    const qOptions = [];
    this.qOptions.forEach((qOption) => {
      if (qOption.name && qOption.name.trim().length > 0) {
        const qOptionL = cloneDeep(qOption);
        qOptions.push(qOptionL);
      }
    });

    return {
      showAnswers,
      correction,
      qTitle,
      qTitleAr,
      qOptions: qOptions,
      rightOption,
      imageUrl2,
      imageFiles2,
      fileObjsImage2,
      isImageDeleted2,
      bgAudioUrl,
      bgAudioFiles,
      isBgAudioUrlDeleted,
    };
  }

  render() {
    const {
      showAnswers,
      correction,
      sections,
      qTitle,
      rightOptions,
      rightOption,
      showValidationMsg
    } = this.state;
    const {app, activityData, classes, isXS} = this.props;

    let qTitleTextKey = null;
    let isQuestionRequired = false;
    if (activityData.type === constants.activity.types.GUESS) {
      qTitleTextKey = 'activity.manage.guessTitle';
      isQuestionRequired = false;
    } else {
      qTitleTextKey = 'activity.manage.questionTitle';
      isQuestionRequired = true;
    }

    let imagePlaceholderId = 'activity.manage.questionImage';
    if (activityData.type === constants.activity.types.GUESS) {
      imagePlaceholderId = 'activity.manage.guessImage';
    }

    // const showImageInColumn = isXS;
    const showImageInColumn = true;
    const showGameImageUrl2 = activityData.type === constants.activity.types.GUESS
      || activityData.type === constants.activity.types.QUESTION;
    const showRightOption = activityData.type === constants.activity.types.GUESS;
    const showAnswerResult = false; // activityData.type === constants.activity.types.QUESTION;

    return (
      <div className={classes.formActivityWide}>
        {/*{activityData.type === constants.activity.types.GUESS ?*/}
        {/*  <React.Fragment>*/}
        {/*    <SectionHeaderView labelId={'activity.bgAudio'} />*/}
        {/*    {this.getBgAudioView(0)}*/}
        {/*    <FieldSpace multiplier={2}/>*/}
        {/*  </React.Fragment>*/}
        {/*  : null*/}
        {/*}*/}

        {/*<SectionHeaderView labelId={'activity.question'} />*/}
        <div className={isXS ? classes.flexRowNoCenter : classes.viewColumnFullWidthNoCenter1}>
          {showGameImageUrl2 && showImageInColumn ?
            <React.Fragment>
              {!isXS ? <MediaPlaceholder labelId={imagePlaceholderId} /> : null}
              <SingleFilePicker
                key={'SFP1'}
                required={false}
                hideDropzoneText={true}
                size={isXS ? 'xsmall' : 'small'}
                filesLimit={1}
                showPreviewsInDropzone={true}
                acceptedFiles={ACCEPTED_IMAGE_MIMES}
                maxFileSize={IMAGE_MAX_SIZE}
                maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
                aspectRatio={16/9}
                initialFiles={this.initialFiles2}
                onChange={(files) => {
                  this.onChangeFiles(files, 'imageUrl2');
                }}
                onDelete={(file) => {
                  this.onDeleteFile(file, 'imageUrl2');
                }}
              />
              <FieldSpace vertical={isXS}/>
            </React.Fragment>
            : null
          }

          <TextField
            variant="filled"
            required
            fullWidth
            multiline
            rows={isXS ? 1 : 2}
            rowsMax={8}
            size="small"
            type="text"
            id="qTitle"
            name="qTitle"
            label={<FormattedMessage id={activityData.type === constants.activity.types.GUESS ? 'activity.guessTitle' : 'activity.questionTitle'} />}
            InputProps={{disableUnderline: true}}
            inputProps={{maxLength: 200}}
            value={qTitle}
            onChange={this.onChange}
            error={showValidationMsg && this.isQuestionTitleIncorrect(qTitle)}
            helperText={showValidationMsg && this.isQuestionTitleIncorrect(qTitle) && <FormattedMessage id='generic.validation.required' />}
          />
        </div>
        <FieldSpace multiplier={2} />

        <SectionHeaderView labelId={'activity.options'} subLabelId={'activity.hintQuestionOptions'} />
        <div style={{margin: isXS ? -6 : -8}}>
          <GridList spacing={0} cols={isXS ? 2 : 2} className={classes.optionsWrapper} cellHeight={'auto'}>
            {this.qOptions.map((option, optionIndex) => this.getQuestionOptionView(optionIndex, option.name, option.nameAr))}
          </GridList>
          {/*<FormHelperText className={classes.helper} style={{marginTop: -2, marginBottom: 2, paddingLeft: isXS ? 18 : 20}}><FormattedMessage id='activity.hintQuestionOptions' /></FormHelperText>*/}
        </div>
        <FieldSpace />

        {showRightOption ?
          <React.Fragment>
            <FieldSpace multiplier={1}/>
            <SectionHeaderView labelId={'activity.questionRightOption'} extraBottomSpace={true}/>
            <FormControl
              fullWidth
              required
              variant="filled"
              size="small"
              error={showValidationMsg && !rightOption}>
              <InputLabel id="selectLabelId" disabled={rightOptions.length === 0}>{<FormattedMessage id='activity.selectRightOption'/>}</InputLabel>
              <Select
                style={{maxWidth: window.appWidth - 32}}
                disabled={rightOptions.length === 0}
                disableUnderline={true}
                labelId="selectLabelId"
                id={"rightOption"}
                name="rightOption"
                value={rightOption}
                onChange={this.onChangeRightOption.bind(this)}>
                {map(rightOptions, (item) => {
                  return <MenuItem key={''+ item.optionNo} value={item.optionNo}>{item.name}</MenuItem>
                })}
              </Select>
            </FormControl>
            <FieldSpace multiplier={2} />
          </React.Fragment>
          : null
        }

        {activityData.type === constants.activity.types.GUESS ?
          <React.Fragment>
            <div className={classes.viewRowNoCenter}>
              <div style={{marginBottom: -SECTION_HEADER_WITH_SUBTITLE_BOTTOM_SPACE}}>
                <SectionHeaderView labelId={'activity.showCheckRightOption'} subLabelId={'activity.showCheckRightOptionHint'}/>
              </div>
              <Switch
                checked={correction}
                onChange={this.onChecked}
                id="correction"
                name="correction"
                color="primary"
              />
            </div>
            <FieldSpace multiplier={2} />
          </React.Fragment>
          : null
        }

        {showAnswerResult ?
          <React.Fragment>
            <FieldSpace multiplier={1}/>
            <div className={classes.viewRow}>
              <div style={{marginBottom: -6}}>
                <SectionHeaderView labelId={'activity.showAnswerDistribution'}/>
              </div>
              <Switch
                checked={showAnswers}
                onChange={this.onChecked}
                id="showAnswers"
                name="showAnswers"
                color="primary"
              />
            </div>
          <FieldSpace />
          </React.Fragment>
          : null
        }
      </div>
    )
  }

  getBgAudioView(space = FIELD_SPACE) {
    const {activityData, app, isXS} = this.props;
    const {showValidationMsg} = this.state;
    let previewImage = null;
    let isRequired = false;
    let size = isXS ? 'xsmall' : 'small';
    let imagePlaceholderId = 'activity.manage.bgAudio';
    const maxWidthHeight = (activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) ? IMAGE_MAX_WIDTH_HEIGHT : IMAGE_PROFILE_MAX_WIDTH_HEIGHT;

    let error = null;

    return (
      <div style={{}}>
        <SingleFilePicker
          key={'SFP1'}
          required={isRequired}
          hideDropzoneText={true}
          size={'xsmall'}
          filesLimit={1}
          showPreviewsInDropzone={true}
          acceptedFiles={ACCEPTED_AUDIO_MIMES}
          maxFileSize={AUDIO_MAX_SIZE}
          maxDuration={this.maxBgAudioDuration}
          initialFiles={this.bgAudioInitialFiles}
          onError={this.onErrorFiles}
          onChange={(files) => {
            this.onChangeFiles(files, 'bgAudioUrl');
          }}
          onDelete={(file) => {
            this.onDeleteFile(file, 'bgAudioUrl');
          }}
          error={error != null}
          errorText={error}
        />
      </div>
    );
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  isQuestionTitleIncorrect(qTitle) {
    const {activityData} = this.props;
    return (!qTitle || qTitle.trim().length === 0);
  }

  isRightOptionIncorrect() {
    const {activityData} = this.props;
    let {rightOption} = this.state;
    rightOption = ValueHelper.getEnglishValue(rightOption);
    return activityData.type === constants.activity.types.GUESS && (!rightOption || rightOption < 1 || rightOption > this.qOptions.length);
  }

  getQuestionOptionsView() {
    const {qTitle, showValidationMsg} = this.state;
    const {activityData, classes} = this.props;
    let views = [];
    let count = 1;
    this.qOptions.forEach((item) => {
      views.push(this.getQuestionOptionView(count, item.name, item.nameAr));
      count++;
    });
    const questionOptionMaxLimit = 8;
    const isQuestionOptionLimitReached = this.qOptions.length === questionOptionMaxLimit;
    const canAddNewQuestionOption = !isQuestionOptionLimitReached && (activityData.type === constants.activity.types.GUESS || qTitle) && this.areQuestionOptionsCorrect();
    return (
      <div className={classes.viewColumnFullWidth}>
        {views}
        <div className={classes.viewRowFullWidth}>
          <FormControl
            required
            size="small"
            error={showValidationMsg && (!this.qOptions || this.qOptions.length === 0)}>
            <Button
              variant={"outlined"}
              color="primary"
              disabled={!canAddNewQuestionOption}
              startIcon={<AddIcon />}
              onClick={this.onAddNewQuestionOptionClicked}>
              {<FormattedMessage id={count === 1 ? 'activity.manage.addQuestionOption' : 'activity.manage.addAnotherOption'} />}
            </Button>
            {showValidationMsg && (!this.qOptions || this.qOptions.length === 0) && <FormHelperText className={classes.helperError}><FormattedMessage id='activity.validation.optionRequired' /></FormHelperText>}
          </FormControl>
        </div>
      </div>
    );
  }

  getQuestionOptionView(optionIndex, optionEn, optionAr) {
    const {showValidationMsg} = this.state;
    const {classes, isXS} = this.props;
    const optionNumber = optionIndex + 1;
    const isOptionIncorrect = showValidationMsg && optionIndex === 0 && (!optionEn || optionEn.trim().length === 0);
    let disabled = false;
    let prevOption = null;
    if (optionIndex > 0) {
      prevOption = this.qOptions[optionIndex - 1];
      disabled = !prevOption.name || prevOption.name.trim().length === 0;
    }
    return (
      <div key={'O'+ optionNumber} className={classes.viewColumn} style={{padding: isXS ? 6 : 8}}>
        {/*<IconButton*/}
        {/*  size={'small'}*/}
        {/*  className={classes.buttonRemoveSmall}*/}
        {/*  onClick={() => {*/}
        {/*    this.qOptions.splice(optionNumber - 1, 1);*/}
        {/*    this.reloadView();*/}
        {/*  }}>*/}
        {/*  <CloseIcon fontSize={'inherit'} style={{color: ColorWhite}} />*/}
        {/*</IconButton>*/}
        {/*<Space vertical={8} />*/}
        <div className={classes.flexRowNoCenter}>
          <div className={classes.flex1}>
            <TextField
              disabled={disabled}
              variant="filled"
              required={optionIndex === 0}
              fullWidth
              size="small"
              type="text"
              id="optionEn"
              name="optionEn"
              label={<FormattedMessage id={'activity.manage.questionOption'} values={{value: optionNumber}} />}
              InputProps={{disableUnderline: true}}
              inputProps={{maxLength: 40}}
              value={optionEn}
              onChange={(event) => {
                const value = event.target.value;
                const oldValue = this.qOptions[optionIndex].name;
                this.qOptions[optionIndex].name = value;

                let isRightOptionPresent = false;
                const rightOptions = [];
                this.qOptions.forEach((qOption) => {
                  if (qOption.name && qOption.name.trim().length > 0) {
                    rightOptions.push(qOption);
                    if (qOption.optionNo === this.state.rightOption) {
                      isRightOptionPresent = true;
                    }
                  }
                });
                const rightOption = isRightOptionPresent ? this.state.rightOption : '';
                this.updateState({rightOptions, rightOption, showValidationMsg: false});
              }}
              error={isOptionIncorrect}
              helperText={isOptionIncorrect && <FormattedMessage id='activity.validationOptionRequired' />}
            />
          </div>
        </div>
      </div>
    );
  }

  areQuestionOptionsCorrect() {
    let isCorrect = true;
    const firstOption = this.qOptions[0];
    if (!firstOption.name || firstOption.name.trim().length === 0) {
      isCorrect = false;
    } else if (!firstOption.name || firstOption.name.trim().length === 0) {
      isCorrect = false;
    }
    return isCorrect;
  }

  onAddNewQuestionOptionClicked = () => {
    this.qOptions.push({
      id: -(this.qOptions.length + 1),
      name: '',
      nameAr: ''
    });
    this.reloadView();
  };

  onChangeRightOption = (event) => {
    this.updateState({rightOption: event.target.value, showValidationMsg: false});
  };

  onChangeFiles(files, id) {
    const {
      imageUrl1,
      imageUrl2,
      bgAudioUrl
    } = this.state;

    let eFileUrl = null;
    let keyFileUrl = null;
    let keyFiles = null;
    let keyFileObjs = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
      keyFileObjs = 'fileObjsImage1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
      keyFileObjs = 'fileObjsImage2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eFileUrl)) {
          lFileUrl = eFileUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      imageUrl1,
      imageFiles1,
      fileObjsImage1,
      imageUrl2,
      imageFiles2,
      fileObjsImage2,
      bgAudioUrl,
      bgAudioFiles,
    } = this.state;

    let eFileUrl = null;
    let eFiles = null;
    let eFileObjs = null;
    let keyFileUrl = null;
    let keyFiles = null;
    let keyFileObjs = null;
    let keyIsFileDeleted = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      eFiles = imageFiles1;
      eFileObjs = fileObjsImage1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
      keyFileObjs = 'fileObjsImage1';
      keyIsFileDeleted = 'isImageDeleted1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      eFiles = imageFiles2;
      eFileObjs = fileObjsImage2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
      keyFileObjs = 'fileObjsImage2';
      keyIsFileDeleted = 'isImageDeleted2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      eFiles = bgAudioFiles;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
      keyIsFileDeleted = 'isBgAudioDeleted';
    }

    let lFiles = [];
    let lFileUrl = eFileUrl;
    if (eFiles) {
      let index = 0;
      eFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eFileUrl)) {
      lFileUrl = null;
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles, [keyIsFileDeleted]: true});
  }

  onChecked = (event) => {
    const value = event.target.checked;
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  onChange = (event) => {
    let value = event.target.value;
    if (event.target.name === 'rightOption') {
      value = ValueHelper.getDecimalValue(value);
    } else if (event.target.name === 'qTitle') {
      value = value.replace("\n", " ");
    }
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

}

ManageActivityQuestion.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityQuestion.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = () => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityQuestion))
);
